<div class="loader-container">
  <div class="cssload-loader">
    <div class="cssload-loader-inner"></div>
  </div>

  <span [ngSwitch]="messageIndex">
    <div style="font-weight: bold" fiTranslation="MESSAGE_BRIDGE_LOADING_TIME_00"></div>
    <div *ngSwitchCase="1">
       <div fiTranslation="MESSAGE_BRIDGE_LOADING_TIME_1A"></div>
    </div>
    <div *ngSwitchCase="2">
       <div fiTranslation="MESSAGE_BRIDGE_LOADING_TIME_1B"></div>
    </div>
    <div *ngSwitchCase="3">
       <div fiTranslation="MESSAGE_BRIDGE_LOADING_TIME_1C"></div>
    </div>
    <div *ngSwitchCase="4">
       <div fiTranslation="MESSAGE_BRIDGE_LOADING_TIME_1D"></div>
    </div>
    <div *ngSwitchCase="5">
       <div fiTranslation="MESSAGE_BRIDGE_LOADING_TIME_2A"></div>
    </div>
    <div *ngSwitchCase="6">
       <div fiTranslation="MESSAGE_BRIDGE_LOADING_TIME_2B"></div>
    </div>
    <div *ngSwitchCase="7">
       <div fiTranslation="MESSAGE_BRIDGE_LOADING_TIME_2C"></div>
    </div>
    <div *ngSwitchCase="8">
       <div fiTranslation="MESSAGE_BRIDGE_LOADING_TIME_3A"></div>
    </div>
    <div *ngSwitchCase="9">
       <div fiTranslation="MESSAGE_BRIDGE_LOADING_TIME_3B"></div>
    </div>
    <div *ngSwitchCase="10">
       <div fiTranslation="MESSAGE_BRIDGE_LOADING_TIME_3C"></div>
    </div>
  </span>
</div>
